import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class HomepageSlidersApi extends Api {
  constructor() {
    super('website/homepage_slides/');
  }

  // GET all with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // CREATE new slide
  create = (data) => {
    const formData = new FormData();
    
    // Add all fields to FormData with nested object structure
    formData.append('homepage_slide[title]', data.title || '');
    formData.append('homepage_slide[description]', data.description || '');
    formData.append('homepage_slide[shopping_center_id]', data.shopping_center_id || '');
    formData.append('homepage_slide[position]', data.position || '');
    
    // Add multilingual fields
    formData.append('homepage_slide[title_en]', data.title_en || '');
    formData.append('homepage_slide[title_fr]', data.title_fr || '');
    formData.append('homepage_slide[description_en]', data.description_en || '');
    formData.append('homepage_slide[description_fr]', data.description_fr || '');
    
    // Add file if exists
    if (data.file) {
      formData.append('homepage_slide[file]', data.file);
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/homepage_slides`,
      method: 'POST',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPDATE slide
  update = (id, data) => {
    const formData = new FormData();
    
    // Add all fields to FormData with nested object structure
    formData.append('homepage_slide[title]', data.title || '');
    formData.append('homepage_slide[description]', data.description || '');
    formData.append('homepage_slide[shopping_center_id]', data.shopping_center_id || '');
    formData.append('homepage_slide[position]', data.position || '');
    

    formData.append('homepage_slide[title_en]', data.title_en || '');
    formData.append('homepage_slide[title_fr]', data.title_fr || '');
    formData.append('homepage_slide[description_en]', data.description_en || '');
    formData.append('homepage_slide[description_fr]', data.description_fr || '');
    

    if (data.file) {
      formData.append('homepage_slide[file]', data.file);
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/homepage_slides/${id}`,
      method: 'PUT',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // DELETE slide
  destroy = (id) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/homepage_slides/${id}`,
      method: 'DELETE',
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // GET companies for dropdown
  getCompanies = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // GET filters (shopping_centers, companies, etc)
  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new HomepageSlidersApi(); 